import { useEffect } from 'react';

import { ActionKey, ActionSubjectIdKey, ActionSubjectKey } from '@/analytics/constants';
import { useFastshiftAnalyticsData } from '@/analytics/hooks/use-fastshift-analytics-data';
import { useFireAnalyticsEvents } from '@/analytics/use-fire-analytics-events';

type OrganizationDetailsSectionAnalytics = {
	organizationId: string;
	actionSubjectId:
		| ActionSubjectIdKey.ORGANIZATION_SUMMARY_SECTION
		| ActionSubjectIdKey.ORGANIZATION_DC_INSTANCES_TABLE;
	status: 'normal' | 'empty' | 'error' | null;
};

export const useOrganizationDetailsSectionAnalytics = ({
	organizationId,
	actionSubjectId,
	status,
}: OrganizationDetailsSectionAnalytics) => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(false);
	const { fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

	useEffect(() => {
		if (identityAttrs === null || status === null) {
			return;
		}

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId,
			source: sourceKey,
			attributes: { selectedOrgId: organizationId, status },
		});
	}, [organizationId, actionSubjectId, status, identityAttrs, fireTrackEvent, sourceKey]);
};
